import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

import { ParseService } from '../../../../scan-data/parse-service/parse-service.service';

@Component({
  selector: 'app-carts',
  templateUrl: './carts.component.html',
  styleUrls: ['./carts.component.scss']
})
export class CartsComponent implements OnInit {

  shoppingId: string;
  displayedColumns: string[] = ['id', 'store', 'status', 'createdAt', 'actions'];
  dataSource: MatTableDataSource<Parse.Object<Parse.Attributes>>;
  carts: Parse.Object[];
  isLoading = false;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(
    private route: ActivatedRoute,
    private parseService: ParseService) {
  }

  async ngOnInit(): Promise<void> {
    this.shoppingId = this.route.snapshot.paramMap.get('id');
    this.dataSource = new MatTableDataSource<Parse.Object<Parse.Attributes>>();
    this.dataSource.paginator = this.paginator;

    this.pageEvent({ pageIndex: 0, pageSize: 5, length: 0 });
  }

  async pageEvent(pageEvent: PageEvent): Promise<void> {
    this.isLoading = true;
    this.dataSource.data = [];
    const response = await this.parseService.getCarts(this.shoppingId, pageEvent.pageIndex, pageEvent.pageSize);
    this.carts = response.results;
    this.paginator.length = response.count;
    this.dataSource = new MatTableDataSource<Parse.Object<Parse.Attributes>>(this.carts);
    this.isLoading = false;
  }

}
